// src/pages/partner/PartnerAppointment.jsx

import React, { useState, useEffect } from 'react';
import { db, auth } from '../../firebase/config';
import {
  collection,
  query,
  where,
  onSnapshot,
  updateDoc,
  doc
} from 'firebase/firestore';
import styled from 'styled-components';

const Container = styled.div`
  max-width: 1000px;
  margin: auto;
  padding: 2rem;
`;

const Tabs = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
`;

const Tab = styled.button`
  background: ${({ active }) => (active ? '#291759' : '#eee')};
  color: ${({ active }) => (active ? '#fff' : '#333')};
  padding: 0.6rem 1.5rem;
  border-radius: 8px;
  font-weight: bold;
  border: none;
  cursor: pointer;
`;

const Card = styled.div`
  background: #fff;
  padding: 1.5rem;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  margin-bottom: 1.5rem;
`;

const Label = styled.p`
  margin: 0.3rem 0;
`;

const Input = styled.input`
  margin: 0.5rem 0.5rem 0.5rem 0;
  padding: 0.5rem;
  border-radius: 6px;
  border: 1px solid #ccc;
`;

const Button = styled.button`
  background: #291759;
  color: white;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 6px;
  margin-top: 0.5rem;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
`;

const PartnerAppointment = () => {
  const [tab, setTab] = useState('requests');
  const [appointments, setAppointments] = useState([]);
  const user = auth.currentUser;

  useEffect(() => {
    if (!user) return;
    const q = query(collection(db, 'appointments'), where('partnerId', '==', user.uid));
    const unsub = onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setAppointments(data);
    });
    return () => unsub();
  }, [user]);

  const filteredAppointments = appointments.filter(app => {
    if (tab === 'requests') return app.status === 'pending';
    if (tab === 'upcoming') return app.status === 'approved';
    if (tab === 'past') return app.status === 'completed';
    return false;
  });

  const approveAppointment = async (id) => {
    const date = document.getElementById(`date-${id}`).value;
    const time = document.getElementById(`time-${id}`).value;
    const link = document.getElementById(`link-${id}`).value;

    if (!date || !time || !link) return alert("All fields are required");

    await updateDoc(doc(db, 'appointments', id), {
      status: 'approved',
      date,
      time,
      meetingLink: link
    });

    alert("Appointment approved");
  };

  return (
    <Container>
      <h2>Manage Appointments</h2>
      <Tabs>
        <Tab active={tab === 'requests'} onClick={() => setTab('requests')}>Requests</Tab>
        <Tab active={tab === 'upcoming'} onClick={() => setTab('upcoming')}>Upcoming</Tab>
        <Tab active={tab === 'past'} onClick={() => setTab('past')}>Past</Tab>
      </Tabs>

      {filteredAppointments.length === 0 ? (
        <p>No appointments to show in this tab.</p>
      ) : (
        filteredAppointments.map(app => (
          <Card key={app.id}>
            <Label><strong>Client ID:</strong> {app.customerId}</Label>
            <Label><strong>Message:</strong> {app.message || '-'}</Label>
            <Label><strong>Status:</strong> {app.status}</Label>

            {tab === 'requests' ? (
              <>
                <Input type="date" id={`date-${app.id}`} placeholder="Date" />
                <Input type="time" id={`time-${app.id}`} placeholder="Time" />
                <Input type="text" id={`link-${app.id}`} placeholder="Zoom Link" />
                <br />
                <Button onClick={() => approveAppointment(app.id)}>Approve Appointment</Button>
              </>
            ) : (
              <>
                <Label><strong>Date:</strong> {app.date}</Label>
                <Label><strong>Time:</strong> {app.time}</Label>
                <Label><strong>Zoom Link:</strong> <a href={app.meetingLink} target="_blank" rel="noreferrer">{app.meetingLink}</a></Label>
              </>
            )}
          </Card>
        ))
      )}
    </Container>
  );
};

export default PartnerAppointment;
